import Vue from "vue";
import App from "./App.vue";
import "./assets/style.css";
import "./scss/style.scss";

import config from "./config";

Vue.config.productionTip = true;

import vuetify from "@/plugins/vuetify";
import * as auth from "@/plugins/auth";
import * as msal from "@/plugins/msal.js";
import * as broadcast from "@/plugins/broadcastChannel.js";
import * as logRocket from "@/plugins/logrocket.js";
import * as helpers from "@/plugins/helpers.js";
import * as logs from "@/plugins/logs.js";
import axiosInstance from "@/plugins/axios.js";

import Vuex from "vuex";
import store from "@/store";
import { router } from "@/router";
import VueMask from "v-mask";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPaperPlane,
  faMoneyBillAlt,
  faRecycle,
  faUserFriends,
  faCoins,
  faHourglassHalf,
  faUsers,
  faMoneyCheckAlt,
  faSearch,
  faTicketAlt,
  faSyncAlt,
  faCopy,
  faCog,
  faBox,
  faPlus,
  faPlusCircle,
  faFlag,
  faBars,
  faArrowUp,
  faArrowDown,
  faTimes,
  faEllipsisV,
  faEllipsisH,
  faDollarSign,
  faClipboardList,
  faTrophy,
  faCaretUp,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faIdBadge,
  faComments,
  faDownload,
  faShoppingCart,
  faCalendarAlt,
  faDesktop,
  faFile,
  faUniversity,
  faArrowLeft,
  faLongArrowAltRight,
  faTachometerAlt,
  faIdCard,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faPaperPlane,
  faMoneyBillAlt,
  faRecycle,
  faUserFriends,
  faCoins,
  faHourglassHalf,
  faUsers,
  faMoneyCheckAlt,
  faSearch,
  faTicketAlt,
  faSyncAlt,
  faCopy,
  faCog,
  faBox,
  faPlus,
  faPlusCircle,
  faFlag,
  faBars,
  faArrowUp,
  faArrowDown,
  faTimes,
  faEllipsisV,
  faEllipsisH,
  faDollarSign,
  faClipboardList,
  faTrophy,
  faCaretUp,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faIdBadge,
  faComments,
  faDownload,
  faShoppingCart,
  faCalendarAlt,
  faDesktop,
  faFile,
  faUniversity,
  faArrowLeft,
  faLongArrowAltRight,
  faTachometerAlt,
  faIdCard
);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.component("font-awesome-icon", FontAwesomeIcon);

logRocket.init();

Vue.use(VueGoogleMaps, {
  load: {
    key: logs.isDev()
      ? "AIzaSyB0unUrspqaDqc5zv4IYb35IIQwhIbP9qo" // by localhost
      : "AIzaSyApV4Xd7HvIgCfLJkWLIOc_BBaOaswTBV0", // by *.efundraisingconnections.com
  },

  installComponents: true, // TODO: Registers all google components. Should set to false and register used components manually.
});

const plugins = {
  install() {
    Vue.prototype.$log = logs.log;
    Vue.prototype.$error = logs.error;
    Vue.prototype.$isDev = logs.isDev;
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
    Vue.auth = auth;
    Vue.prototype.$auth = auth;
    Vue.prototype.$msal = msal;
    Vue.prototype.$broadcast = broadcast;
    Vue.prototype.$api_url = config.apiUrl;
    Vue.prototype.$website_url = config.websiteUrl;
    Vue.prototype.$merch_url = config.merchUrl;
    Vue.prototype.$old_ui = config.oldUi;
    Vue.prototype.$axios = axiosInstance;
  },
};
Vue.use(plugins);

import dataHandlingMixin from "@/mixins/dataHandling.js";
Vue.mixin(dataHandlingMixin);

Vue.use(Vuex);
Vue.use(VueMask);

// Initialize MSAL
msal.msalInstance.initialize().then(() => {
  new Vue({
    vuetify,
    store,
    router: router,
    render: (h) => h(App),
    created() {
      // Initial authentication check is now handled by router guard
    },
  }).$mount("#app");
});
